import type { OptionType } from "components/inputs";
import { Select } from "components/inputs";
import { useMemo } from "react";
import type {
  CostProjectionDataType,
  MSADataType,
  DocumentManagementDataType,
} from "types/DataTypes";

import { useServiceDOI } from "./useServiceDOI";

type DOIHeaderSelectProps = {
  service: MSADataType | CostProjectionDataType | DocumentManagementDataType;
};

/* this is used for MSA, Cost Projection, and Document Management, services that use service-date-of-injury
this is necessary for ICD codes and accepted/denied conditions, etc. fields on the service-date-of-injury table */
export const DOIHeaderSelect = ({ service }: DOIHeaderSelectProps) => {
  const { serviceDOIs, selectedServiceDoiId, selectDoi, isLoading } =
    useServiceDOI(service);

  const options = useMemo(() => {
    if (!serviceDOIs) return [];

    return serviceDOIs.map((doi) => {
      return {
        label: doi.date.substring(0, 10),
        value: doi.id,
      };
    });
  }, [serviceDOIs]);

  const selectedOption = useMemo(
    () =>
      options.find(
        (option) =>
          option.value?.toString() === selectedServiceDoiId?.toString(),
      ),
    [options, selectedServiceDoiId],
  );

  if (isLoading) {
    return <div className="doi-header-select">Loading...</div>;
  }

  if (!serviceDOIs?.length) {
    return <div className="doi-header-select">No dates available</div>;
  }

  return (
    <div className="doi-header-select">
      <Select
        className="kaboodle__control"
        onChange={(o: OptionType) => selectDoi(o?.value?.toString() || null)}
        name="doi"
        value={selectedOption}
        options={options}
        isClearable={false}
        isSearchable={false}
      />
    </div>
  );
};
